import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { mockData } from '../../data/mock';
import { ContactInfoCard, ContactLinkList } from './ContactInfoCard';
import { WhatsAppCard } from './WhatsAppCard';

const { contact } = mockData;

const PHONES = [
  { caption: 'Meena R Kakade', value: contact.phone.meena },
  { caption: 'Neeraj R Kakade', value: contact.phone.neeraj },
  { caption: 'Office', value: contact.phone.office },
];

const EMAILS = [
  { caption: 'Meena R Kakade (Loans)', value: contact.email.meena },
  { caption: 'Neeraj R Kakade (Property)', value: contact.email.neeraj },
];

export const ContactInfo = () => (
  <div className="space-y-6" data-testid="contact-info">
    <ContactInfoCard icon={Phone} title="Call Us">
      <ContactLinkList items={PHONES} hrefPrefix="tel:" />
    </ContactInfoCard>

    <ContactInfoCard icon={Mail} title="Email Us">
      <ContactLinkList items={EMAILS} hrefPrefix="mailto:" linkClass="text-sm break-all" />
    </ContactInfoCard>

    <ContactInfoCard icon={MapPin} title="Visit Us">
      <p className="text-gray-600">{contact.address}</p>
    </ContactInfoCard>

    <ContactInfoCard icon={Clock} title="Business Hours">
      <p className="text-gray-600">{contact.hours}</p>
      <p className="text-sm text-gray-500 mt-1">{contact.workingDays}</p>
    </ContactInfoCard>

    <WhatsAppCard />
  </div>
);
